export const PIX_STORE_KEYS = 'PIX_STORE_KEYS'
